import { render, staticRenderFns } from "./CompaniesBox.vue?vue&type=template&id=720420fd&lang=pug"
import script from "./CompaniesBox.vue?vue&type=script&lang=js"
export * from "./CompaniesBox.vue?vue&type=script&lang=js"
import style0 from "./CompaniesBox.vue?vue&type=style&index=0&id=720420fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports